<template>
  <v-dialog v-model="dialog" width="768px" persistent>
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="primary" dark v-bind="attrs" v-on="on" depressed><v-icon>mdi-plus</v-icon> Aggiungi</v-btn>
    </template>
    <v-card class="rounded-lg">
      <v-card-title>
        <span class="text-h5">Nuova rilevazione</span>
      </v-card-title>
      <v-card-text>
        <!-- FORM -->
        <v-form v-model="valid" ref="form" lazy-validation>
          <!-- Rilevazione -->
          <div class="text-body-1">Periodo di rilevazione</div>
          <v-row>
            <v-col sm="3">
              <v-select
                v-model.number="form.year"
                label="Anno*"
                :items="[2022, 2023]"
                :rules="[required]"
                required
                outlined
                dense
              ></v-select>
            </v-col>
            <v-col cols="6">
              <v-select
                v-model.number="form.week"
                label="Settimana*"
                :items="weekItems"
                :disabled="!form.year"
                :rules="[required]"
                required
                outlined
                dense
              ></v-select>
            </v-col>
          </v-row>

          <div class="text-body-1">Periodo di somministrazione</div>
          <v-row>
            <v-col md="4">
              <v-menu
                v-model="menu1"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.valid_until"
                    label="Data scadenza compilazione*"
                    :rules="[required]"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    clearable
                    dense
                  ></v-text-field>
                </template>
                <v-date-picker v-model="form.valid_until" @input="menu1 = false"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col md="4">
              <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.valid_from"
                    label="Inizio periodo compilazione (opzionale)"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    clearable
                    dense
                  ></v-text-field>
                </template>
                <v-date-picker v-model="form.valid_from" @input="menu2 = false"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col md="4">
              <v-text-field v-model="form.sample" label="Campione" outlined hide-details="auto" dense />
            </v-col>
          </v-row>

          <!-- Veicoli-->
          <div class="text-body-1">Targhe</div>
          <v-row v-for="(v, i) in form.vehicles" :key="i">
            <v-col cols="12" md="3">
              <v-text-field
                v-model="form.vehicles[i].targa"
                label="Targa*"
                :rules="[required]"
                required
                maxlength="7"
                hide-details="auto"
                outlined
                dense
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                v-model="form.vehicles[i].province"
                label="Prov. immatricolazione*"
                :items="provinces"
                :rules="[required]"
                required
                outlined
                dense
                hide-details="auto"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field
                v-model.number="form.vehicles[i].capacity"
                label="Portata utile*"
                type="number"
                :rules="[required]"
                min="0"
                required
                suffix="q"
                outlined
                dense
                hide-details="auto"
              />
            </v-col>
            <v-col>
              <v-btn icon :disabled="form.vehicles.length === 1" @click="removeVehicle(i)">
                <v-icon>mdi-trash-can-outline</v-icon>
              </v-btn>
            </v-col>
          </v-row>

          <v-container class="text-right">
            <v-row no-gutters>
              <v-col md="6" class="text-left"><small>* Campo obbligatorio</small></v-col>
              <v-col md="6">
                <v-btn text color="primary" @click="addVehicle"> <v-icon>mdi-plus</v-icon>Aggiungi targa</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="dialog = false"> Annulla </v-btn>
        <v-btn color="primary" text @click="onSubmit"> Salva </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// Third-party libs
import { format } from 'date-fns'

// Data
import italyCities from '@/data/italy-cities.json'
import italyProvinces from '@/data/provinces.json'

// Helpers
import { getWeekDates } from '@/helpers'

// Validations
import { required } from '@/validations'

// Component
export default {
  name: 'CreateSurveysForm',
  props: {},
  data() {
    return {
      dialog: false,
      menu1: false,
      menu2: false,
      valid: true,
      form: {
        year: null,
        week: null,
        valid_from: null,
        valid_until: null,
        sample: '',
        vehicles: [{ targa: '', capacity: null, province: null }],
      },
      cities: italyCities.map((c) => c.name).sort(),
      provinces: Object.keys(italyProvinces).sort(),
      required,
    }
  },
  computed: {
    weekItems() {
      return Array.from({ length: 52 }, (value, index) => {
        if (!this.form.year) return []

        const weekNumber = index + 1
        const [startDate, endDate] = getWeekDates(this.form.year, weekNumber)

        const text = `${weekNumber} - dal ${format(startDate, 'dd/MM/yy')} al ${format(endDate, 'dd/MM/yy')}`

        return { value: weekNumber, text }
      })
    },
  },
  methods: {
    removeVehicle(index) {
      this.form.vehicles.splice(index, 1)
    },
    addVehicle() {
      this.form.vehicles.push({ targa: '', capacity: null, province: '' })
    },
    async onSubmit() {
      await this.$refs.form.validate()

      if (this.valid) {
        const data = this.form.vehicles.map((vehicle) => ({
          year: this.form.year,
          week: this.form.week,
          valid_from: this.form.valid_from,
          valid_until: this.form.valid_until,
          sample: this.form.sample,
          vehicle_targa: vehicle.targa,
          vehicle_load_capacity: vehicle.capacity,
          vehicle_province: vehicle.province,
        }))

        await this.$store.dispatch('surveys/bulkCreate', data)
        this.dialog = false
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
